import React from "react";
import { useState, useRef, useEffect } from "react";

import Button from "react-bootstrap/Button";

import { useForm } from "react-hook-form";
import { getOrgUserGoals } from "../../api/performance/getOrgUserGoals";
import { getOrgGoal } from "../../api/OrganizationGoal/getOrgGoal";

import { useAuthContext } from "../../hooks";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
function Index() {
  const [lgShow, setLgShow] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const auth = useAuthContext();
  const [userGoals, setUserGoals] = useState<any[]>([]);
  const [orgGoals, setOrgGoals] = useState<any[]>([]);
  const fetchUserGoals = async () => {
    await getOrgUserGoals(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0]
    )
      .then((e) => {
        console.log(e);
        setUserGoals(e);
      })
      .catch((e) => console.log(e));
  };
  const fetchOrgGoals = async () => {
    await getOrgGoal(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0]
    )
      .then((e) => {
        console.log(e);
        setOrgGoals(e);
      })
      .catch((e) => console.log(e));
  };
  const handleUserComment = async (e: any) => {
    console.debug("data > ", e);
  };
  useEffect(() => {
    fetchUserGoals();
    fetchOrgGoals();
  }, []);
  console.log(userGoals);
  return (
    <>
      <div className="request-conatiner1">
        {userGoals?.length > 0 ? (
          userGoals?.map((data) => {
            return (
              <>
                <div>Evaluation:{data?.evaluation}</div>
                <Button onClick={() => navigate("goalCheck")}>
                  Performance History
                </Button>
              </>
            );
          })
        ) : (
          <div>No user goals found.</div>
        )}
      </div>
    </>
  );
}

export default Index;
